/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import InnerbarDashboardController from '../../common/components/InnerBarDashboard/InnerbarDashboardController';
import announcement from '../../assets/images/announcement.svg';
import PlainSearchCard from '../../common/components/PlainSearchCard';
import { DataGrid } from '@mui/x-data-grid';
import { fonts } from '../../common/themes/themes';
import './Announcement.css';
import GetPayHistoryActionBox from '../../common/components/ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import ViewAnnounceController from '../../common/Modals/Announcement/ViewAnnounceController';
import Loader from '../../common/Lottifiers/Loader/Loader';
import { useAppSelector } from '../../infra/hooks';

interface propsType {
  announcementData: any;
  setTextFilterSearch: (Data: any) => void;
  isLoading?: boolean;
  trans?: any;
  i18n?: any;
}
const AnnouncementPresenter: React.FC<propsType> = ({
  announcementData,
  setTextFilterSearch,
  isLoading,
  trans,
  i18n,
}) => {
  const [viewAnnouncement, setViewAnnouncement] = useState(false);
  const [announceViewData, setAnnounceViewData] = useState({});
  const [pageSize, setPageSize] = React.useState<number>(10);
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);

  const handleViewAnnouncement = (params: any) => {
    setAnnounceViewData(params.row);
    setViewAnnouncement(true);
  };

  const tableColumns: any = [
    {
      field: 'date',
      headerName: 'Date',
      flex: 1,
      align: 'center',
    },
    {
      field: 'content',
      headerName: '',
      flex: 1,
      renderCell: (params: any) => {
        return (
          <>
            <Grid container style={{ marginTop: '1.5em' }}>
              <Grid item xs={12}>
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.title,
                    fontWeight: fonts.fontWeight,
                  }}
                >
                  {params.value}
                </Typography>
              </Grid>
            </Grid>
          </>
        );
      },
    },
    {
      field: 'action',
      headerName: '',
      align: 'center',
      flex: 1,
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              handleViewAnnouncement(params);
            }}
          />
        );
      },
    },
  ];

  return (
    <>
      <Grid
        container
        style={{
          height: '100%',
          marginTop: isHRView ? '-1em' : '4em',
          width: '100vw',
          paddingRight: i18n.language == 'ar' ? '' : '8em',
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            display: 'flex',
          }}
        >
          <Grid
            container
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
            }}
          >
            <Grid
              item
              xs={2}
              sm={2}
              md={2}
              lg={2}
              style={{
                marginRight: i18n.language == 'ar' ? '6em' : '',
                minWidth: '15em',
              }}
            >
              <InnerbarDashboardController />
            </Grid>

            <Grid
              item
              xs={10}
              sm={10}
              md={10}
              lg={10}
              sx={{
                backgroundColor: '#F5F5FA',
                width: '100%',
                height: 'auto',
                padding: '1.75em',
              }}
            >
              <Grid container style={{ marginBottom: '-2em' }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Box
                    style={{
                      backgroundImage: `url(${announcement})`,
                      backgroundSize: '100%',
                      backgroundPosition: 'top',
                      backgroundRepeat: 'no-repeat',

                      flexDirection: 'row',
                      width: '100%',

                      height: '152px',
                    }}
                  >
                    <Grid container>
                      <Grid item xs={4}></Grid>
                      <Grid item style={{ marginTop: '4em' }}>
                        <Box
                          style={{
                            width: '380px',
                          }}
                        >
                          <PlainSearchCard
                            onChange={(e: any) => {
                              setTextFilterSearch(e);
                            }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              {isLoading ? (
                <Loader height={200} width={300} />
              ) : (
                <Grid container>
                  <Grid
                    item
                    sm={12}
                    md={12}
                    lg={12}
                    style={{ backgroundColor: 'white' }}
                  >
                    <DataGrid
                      sx={{
                        fontSize: fonts.subtitle,
                        color: '#081735',
                        fontFamily: fonts.fontFamily,
                        resizable: 'true',
                        border: 0,
                        height: '730px',
                      }}
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      rowsPerPageOptions={[10, 20, 30, 40]}
                      disableSelectionOnClick
                      rows={announcementData}
                      columns={tableColumns}
                      getRowHeight={() => 'auto'}
                      headerHeight={0}
                      componentsProps={{
                        pagination: {
                          labelRowsPerPage: trans('Rows per page'),
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* Announcement Modal */}
      {viewAnnouncement && (
        <ViewAnnounceController
          closeModal={() => setViewAnnouncement(false)}
          isModalOpen={viewAnnouncement}
          setAnnounceViewData={announceViewData}
        />
      )}
    </>
  );
};

export default AnnouncementPresenter;
